export const Table_Colums = [
    {colKey:'job_posting_title', colValue:'Title'},
    {colKey:'company', colValue:'Company'},
    {colKey:'country', colValue:'Location'},
    {colKey:'industry', colValue:'Sub-Sector'},
    {colKey:'normalised_title', colValue:'Normalised Role'},
]